/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class StorageConfigurationBaseForSaas {
    type: string;

    protected setDiscriminator(type: string) {
        this.type = type;
    }

    getFixupPrototypeFunction() { return StorageConfigurationBaseForSaas.fixupPrototype; }

    static newInstance(model: Partial<StorageConfigurationBaseForSaas>): StorageConfigurationBaseForSaas {
        let obj = Object.assign(new StorageConfigurationBaseForSaas(), model);
        StorageConfigurationBaseForSaas.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<StorageConfigurationBaseForSaas>): StorageConfigurationBaseForSaas {
        if (!model) return null;
        return StorageConfigurationBaseForSaas.newInstance(<StorageConfigurationBaseForSaas> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: StorageConfigurationBaseForSaas) {
        if (!obj) return;

        models.StorageConfigurationBaseForSaas.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: StorageConfigurationBaseForSaas): boolean {
        switch (obj.type)
        {
            case "StorageConfigurationForAwsSaasUserManagedIndividual":
                Object.setPrototypeOf(obj, models.StorageConfigurationForAwsSaasUserManagedIndividual.prototype);
                break;
            case "StorageConfigurationForAwsSaasUserManagedOnboarded":
                Object.setPrototypeOf(obj, models.StorageConfigurationForAwsSaasUserManagedOnboarded.prototype);
                break;
            case "StorageConfigurationForAzureSaasUserManagedIndividual":
                Object.setPrototypeOf(obj, models.StorageConfigurationForAzureSaasUserManagedIndividual.prototype);
                break;
            case "StorageConfigurationForAzureSaasUserManagedOnboarded":
                Object.setPrototypeOf(obj, models.StorageConfigurationForAzureSaasUserManagedOnboarded.prototype);
                break;
            case "StorageConfigurationForGcpSaasUserManagedIndividual":
                Object.setPrototypeOf(obj, models.StorageConfigurationForGcpSaasUserManagedIndividual.prototype);
                break;
            case "StorageConfigurationForGcpSaasUserManagedOnboarded":
                Object.setPrototypeOf(obj, models.StorageConfigurationForGcpSaasUserManagedOnboarded.prototype);
                break;
            case "StorageConfigurationForOciSaasUserManagedIndividual":
                Object.setPrototypeOf(obj, models.StorageConfigurationForOciSaasUserManagedIndividual.prototype);
                break;
            case "StorageConfigurationForOciSaasUserManagedOnboarded":
                Object.setPrototypeOf(obj, models.StorageConfigurationForOciSaasUserManagedOnboarded.prototype);
                break;
            case "StorageConfigurationForSaasUserManaged":
                Object.setPrototypeOf(obj, models.StorageConfigurationForSaasUserManaged.prototype);
                break;
        }
        return true; // Tell the caller this is a polymorphic type, it should not overwrite the prototype.
    }

    static getTypeHierarchy(): (typeof StorageConfigurationBaseForSaas)[] {
        return [
            models.StorageConfigurationForAwsSaasUserManagedIndividual,
            models.StorageConfigurationForAwsSaasUserManagedOnboarded,
            models.StorageConfigurationForAzureSaasUserManagedIndividual,
            models.StorageConfigurationForAzureSaasUserManagedOnboarded,
            models.StorageConfigurationForGcpSaasUserManagedIndividual,
            models.StorageConfigurationForGcpSaasUserManagedOnboarded,
            models.StorageConfigurationForOciSaasUserManagedIndividual,
            models.StorageConfigurationForOciSaasUserManagedOnboarded,
            models.StorageConfigurationForSaasUserManaged,
        ];
    }

    fixupFields() {
    }

}
